<div class="filter-section">
    <label>{{name | langtranslate}} <span *ngIf="required" class="required">*</span></label>
    <div class="">
        <input type="text" class="form-control" [formControl]="textForm">
    </div>
</div>